import SlideFrame from "@/components/SlideFrame";
import { Check, Lock, Sparkles, ArrowRight } from "lucide-react";
import { packFor } from "@/lib/industryPack";

/* ============================ 08 · The Offer (limited 20% lock-in) ============================ */
export function S_Enterprise({ idx, total, prospect }) {
  const pack = packFor(prospect);

  const full = { monthly: 3225, install: 5000 };
  const locked = { monthly: Math.round(full.monthly * 0.8), install: Math.round(full.install * 0.8) };

  const included = [
    "Full platform access — every Guardian agent + module",
    "20 hours / month of fractional compliance team",
    "Additional hours billed at $200 / hr",
    "$5,000 installation covers 45-day rollout + prototyping",
    "Migration + handoff included — production-ready Day 46",
  ];

  return (
    <SlideFrame idx={idx} total={total} kicker="The Offer" dark>
      <div className="grid grid-cols-12 gap-8 pt-2 md:pt-4">
        <div className="col-span-12 md:col-span-7">
          <div className="inline-flex items-center gap-2 mono text-[10px] uppercase tracking-[0.22em] text-sun-700 border border-sun-500/40 bg-sun-500/10 rounded-full px-3 py-1.5">
            <Lock className="h-3 w-3" /> Limited audience · 20% locked in when you approve the prototype
          </div>
          <h2 className="serif font-light text-5xl md:text-6xl leading-[1.04] tracking-tight mt-5">
            This deck is going to a <em className="italic text-sun-600">short list.</em>
          </h2>
          <p className="mt-5 text-ink-900/80 text-lg leading-relaxed max-w-2xl">
            Only a small number of companies get this version of the offer. Approve the prototype
            from the last slide and your pricing is <strong className="text-ink-900">locked at the 20% discount
            for the first 12 months</strong> — no renegotiation, no fine print.
          </p>

          <div className="mt-7 border border-ink-900/12 rounded-md p-5 bg-white/70" data-testid="offer-included">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-sun-700">/ what you get</div>
            <ul className="mt-3 space-y-2 text-sm md:text-base text-ink-900/85 leading-relaxed">
              {included.map((t) => (
                <li key={t} className="flex items-start gap-2.5"><Check className="h-4 w-4 text-sun-700 mt-1 flex-shrink-0" strokeWidth={2.5} /><span>{t}</span></li>
              ))}
            </ul>
          </div>

          <p className="mt-4 mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55">
            {pack.kind === "law"
              ? "/ law-firm offer · co-branded client environment + referral economics included"
              : pack.kind === "association"
              ? "/ association offer · multi-tenant template + per-member sub-accounts included"
              : pack.kind === "industrial"
              ? "/ industrial offer · EHS + supply-chain + export-controls scope included"
              : "/ standard offer · platform + fractional team + 45-day rollout"}
          </p>
        </div>

        {/* Price card */}
        <div className="col-span-12 md:col-span-5">
          <div className="border-2 border-sun-500/50 rounded-md bg-gradient-to-br from-sun-500/10 to-ember-500/5 p-6" data-testid="offer-price-card">
            <div className="flex items-center gap-2">
              <Sparkles className="h-4 w-4 text-sun-700" />
              <div className="mono text-[10px] uppercase tracking-[0.22em] text-sun-700">Locked when you approve</div>
            </div>
            <div className="mt-3">
              <div className="serif text-5xl md:text-6xl text-ink-900 leading-none">
                ${locked.monthly.toLocaleString()}
                <span className="text-base font-normal text-ink-900/65"> /mo</span>
              </div>
              <div className="text-sm text-ink-900/55 mt-1">
                <span className="line-through opacity-60">${full.monthly.toLocaleString()}/mo</span>
                <span className="mono text-sun-700 ml-2">20% off</span>
              </div>
            </div>
            <div className="mt-5 border-t border-ink-900/10 pt-4">
              <div className="serif text-2xl text-ink-900">
                + ${locked.install.toLocaleString()}
                <span className="text-sm font-normal text-ink-900/65"> installation</span>
              </div>
              <div className="text-xs text-ink-900/55 mt-0.5">
                <span className="line-through opacity-60">${full.install.toLocaleString()}</span>
                <span className="mono text-sun-700 ml-2">covers all 45 days</span>
              </div>
            </div>

            <div className="mt-6 border border-ink-900/10 rounded-md bg-white p-3">
              <div className="mono text-[9px] uppercase tracking-[0.22em] text-sun-700">/ year-1 total</div>
              <div className="serif text-2xl text-ink-900 mt-0.5">
                ${(locked.monthly * 12 + locked.install).toLocaleString()}
              </div>
              <div className="text-[11px] text-ink-900/60 mt-0.5">vs. {pack.proofKpi}</div>
            </div>
          </div>

          <p className="mt-4 mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55 inline-flex items-center gap-1.5">
            <ArrowRight className="h-3 w-3" /> Last slide · Build me a Prototype
          </p>
        </div>
      </div>
    </SlideFrame>
  );
}
